import React  from 'react';
import data from '../data/DesignWorks';
import {Card, Button} from 'react-bootstrap';
import { useHistory } from "react-router-dom";

const DesignPages  = () =>{
  
    let history = useHistory();

    return (
        <div class="row treciasblokas sonai">
        <div className="col-12 pav1 text-center text-dark"> <p> KOMPIUTERINĖS GRAFIKOS DARBAI</p></div>
        <div className="col-12"> <hr className="text-white-50"/></div>
        <div className=" col-12 d-flex flex-wrap flex-row  justify-content-center text-center">
            {
                 data.map((work, index)=>(
                <Card style={{width: '17rem' }} key={index} className="text-center m-1">
                <Card.Body>
                  <Card.Text className="text-center">
                    {work.desc}
                    </Card.Text>
                  </Card.Body>
                  <Card.Img  style={{height: '18rem' }} variant="bottom" src={work.pic} />
                </Card>
              ))
                }
    </div>
    <div class="col-md-12 text-center pt-5 ">
       <Button onClick={() => history.goBack()} className="button"  variant="amber"  active type="submit">GRĮŽTI</Button>
    </div>
  </div>
    )
}

export default DesignPages